import { Box, Typography, useTheme } from '@mui/material';

import SectionTitle from '../../components/SectionTitle';

interface Props {
  disabled?: boolean;
}

const contents = [
  '清醒鎮靜涉及透過靜脈導管注射一種稱為咪達唑侖(Midazolam)的鎮靜劑。清醒鎮靜可減輕疼痛並產生失憶效果.但不會導致完全失去意識。除了能讓病人在檢查過程中無痛，清醒鎮靜還能緩解與檢查相關的壓力與焦慮。\n因此，咪達唑侖通常用於對內視鏡檢查感到高度焦慮或恐懼的病人。\n對某些人而言，鎮靜可能反而會使內視鏡插入時更加困難。此外在某些情況下，即使給予較大量藥物，仍可能無法誘導睡眠。\n然而，由於咪達唑侖的副作用，不可進一步增加劑量。咪達唑侖的副作用包括呼吸困難、血壓降低、心跳加快、打嗝與咳嗽。\n這些症狀通常會自然消失，無需特殊處理。但在極少數情況下，可能發生嚴重副作用，例如呼吸或心臟驟停，此時會進行緊急處置。\n年長者、低血壓、呼吸系統疾病、心臟疾病或其他潛在疾病患者不建議使用咪達唑侖。',
];

const contents2 = [
  '選擇清醒鎮靜的病人，在檢查當日須由親友陪同，\n因為藥效約需2小時或更久才會消退。此外，檢查後不應自行駕駛車輛。',
  '我已充分了解關於咪達唑侖的性質、用途及其副作用，並同意在本次檢查中使用咪達唑侖。\n我也了解，在檢查過程中可能發生意外情況，\n而需要對我（病人）施行額外或其他的處置。\n若在檢查期間發生意外情況，我在此授權並請求我的醫師可採取對我（病人）有醫療必要與適當的處置，\n包括進行其他檢查或手術。',
  '如果您已了解上述症狀、治療方式、風險與可能併發症，請在空格中寫上“我已了解”。',
];

const CautionList = (props: Props) => {
  const { disabled } = props;
  const { palette } = useTheme();

  return (
    <>
      <SectionTitle title="知情同意書關於清醒鎮靜" />
      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents.map((v, i) => {
          if (i === 3) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '14px',
                  lineHeight: '24px',
                  color: `${palette.primary.main}`,
                }}
              >
                {v}
                <p />
              </Typography>
            );
          }
          return (
            <Typography
              sx={{ fontWeight: '400', fontSize: '14px', lineHeight: '24px' }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>

      <Box sx={{ width: '98%', margin: '0px auto 24px auto' }}>
        {contents2.map((v, i) => {
          if (i === 2) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '14px',
                  lineHeight: '24px',
                  color: `${palette.primary.main}`,
                }}
              >
                {v}
                <p />
              </Typography>
            );
          }
          return (
            <Typography
              sx={{ fontWeight: '400', fontSize: '14px', lineHeight: '24px' }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>
    </>
  );
};

export default CautionList;
